/**
 * Admin panelinin desteklenen dilleri — tv-app'teki
 * `presentation/i18n/supportedLocales.ts` ile AYNI sözleşme (iki uygulama ayrı
 * i18next örneği kullanıyor, kayıt paylaşılmıyor; biri değişirse öbürü elle
 * hizalanır).
 *
 * `PLANNED_UI_LOCALES` ürün hedefi, `AVAILABLE_UI_LOCALES` bugün gerçekten
 * çevirisi olan diller. Kullanıcıya yalnız ikincisi gösterilir.
 */
export const PLANNED_UI_LOCALES = ['tr', 'en', 'de', 'es', 'fr', 'ar'] as const;
export type PlannedUiLocale = (typeof PLANNED_UI_LOCALES)[number];

export const AVAILABLE_UI_LOCALES = ['tr', 'en', 'de', 'es', 'fr', 'ar'] as const satisfies readonly PlannedUiLocale[];
export type UiLocale = (typeof AVAILABLE_UI_LOCALES)[number];

const RTL_LOCALES = new Set<PlannedUiLocale>(['ar']);

export type TextDirection = 'ltr' | 'rtl';

export function localeDirection(locale: string): TextDirection {
  return RTL_LOCALES.has(locale as PlannedUiLocale) ? 'rtl' : 'ltr';
}

export const LOCALE_LABELS: Record<PlannedUiLocale, string> = {
  tr: 'Türkçe',
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  ar: 'العربية',
};
